
var validacaoForm = {
  methods:{
      validacaoForm (item, label){
        var errors = []
        item.$params.errors = []
        if (!item.$dirty) { return null }
        if (item.hasOwnProperty("required") && !item.required) {
          item.$params.errors.push('Campo '+label+' é Obrigatório')
          errors = item.$params.errors
          return errors.toString()
        }
        if (item.hasOwnProperty("minValue") && !item.minValue) {
          item.$params.errors.push('Informe valor maior que '+item.$params.minValue.min)
          errors = item.$params.errors
          return errors.toString()
        }
        if (item.hasOwnProperty("minLength") && !item.minLength) {
          item.$params.errors.push('Informe no mínimo '+item.$params.minLength.min+ ' caracteres')
          errors = item.$params.errors
          return errors.toString()
        }
        if (item.hasOwnProperty("maxLength") && !item.maxLength) {
          item.$params.errors.push('Informe no máximo '+item.$params.maxLength.max+ ' caracteres')
          errors = item.$params.errors
          return errors.toString()
        }
        if (item.hasOwnProperty("email") && !item.email) {
          item.$params.errors.push('Insira um e-mail válido') 
          errors = item.$params.errors
          return errors.toString()
        }
        if (item.hasOwnProperty("validaCpfCnpj") && !item.validaCpfCnpj) {
          let doc
          item.$model.length <= 14 ? doc = 'CPF' : doc = 'CNPJ'
          item.$params.errors.push('Insira '+doc+' válido') 
          errors = item.$params.errors
          return errors.toString() 
        }
        if (item.hasOwnProperty("dateValid") && !item.dateValid) {
          item.$params.errors.push('Insira uma data válida') 
          errors = item.$params.errors
          return errors.toString() 
        }
        if (item.hasOwnProperty("dateMinProvisaoValidate") && !item.dateMinProvisaoValidate) {
          item.$params.errors.push('Data deve ser superior a indenização') 
          errors = item.$params.errors
          return errors.toString() 
        }
        if (item.hasOwnProperty("dateMaxProvisaoValidate") && !item.dateMaxProvisaoValidate) {
          item.$params.errors.push('Data max 1 ano da indenização') 
          errors = item.$params.errors
          return errors.toString() 
        }
        if (item.hasOwnProperty("dateMinPagamentoValidate") && !item.dateMinPagamentoValidate) {
          item.$params.errors.push('Data deve ser superior a indenização') 
          errors = item.$params.errors
          return errors.toString() 
        }
        if (item.hasOwnProperty("dateMaxPagamentoValidate") && !item.dateMaxPagamentoValidate) {
          item.$params.errors.push('Data max 1 ano da indenização') 
          errors = item.$params.errors
          return errors.toString() 
        }
        return errors.toString()
      }
  }
};

export default validacaoForm;


// WEBPACK FOOTER //
// ./src/mixins/validacaoForm.js